import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=e898c91c&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=ts"
export * from "./Recharge.vue?vue&type=script&lang=ts"
import style0 from "./Recharge.vue?vue&type=style&index=0&id=e898c91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e898c91c",
  null
  
)

export default component.exports